import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-42541966"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"justify-content":"space-between"} }
const _hoisted_2 = { class: "logo" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/logo.svg" }, null, -1))

import { Search, ShoppingCart } from "@vicons/tabler";
import { NInput, NIcon, NButton, NBadge, NPopover, NSpace } from 'naive-ui'
import { useProductStore } from '@/stores/ProductStore';
import { ref, computed } from "vue";
import { Product } from "@/types/Product";
import { useRouter, useRoute } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderItems',
  setup(__props) {

const store = useProductStore();
const val = ref("");
const showPopover = ref(false);
const popoverMessage = ref("");
const cartButtonHover = ref(false);
let groundTimeout: number;

// store.cart.OnProductAdded((p: Product) => {
//     clearTimeout(groundTimeout);
//     popoverMessage.value = p.title + " added";
//     showPopover.value = true;
//     console.log('test');
//     groundTimeout = setTimeout(function () { showPopover.value = false; }, 3000);
// });

const inputEvent = function name(p: KeyboardEvent) {
    if (p.key == 'Escape') {
        val.value = "";
        store.filterProducts("");
    }
}

const isHomePage = computed(() => {
    return useRouter().currentRoute.value.name === 'home';
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      })
    ]),
    (_unref(isHomePage))
      ? (_openBlock(), _createBlock(_unref(NInput), {
          key: 0,
          round: "",
          placeholder: "Search ...",
          autosize: "",
          clearable: "",
          color: "#71c8cb",
          size: "large",
          onInput: _unref(store).filterProducts,
          onKeydown: inputEvent,
          value: val.value,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((val).value = $event))
        }, {
          prefix: _withCtx(() => [
            _createVNode(_unref(NIcon), { style: { 'margin-right': '5px' } }, {
              default: _withCtx(() => [
                _createVNode(_unref(Search))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["onInput", "value"]))
      : _createCommentVNode("", true),
    _createVNode(_component_router_link, { to: "/cart" }, {
      default: _withCtx(() => [
        _createVNode(_unref(NButton), {
          round: "",
          bordered: "",
          type: "info",
          size: "large",
          color: "#71c8cb",
          ghost: !cartButtonHover.value,
          onMouseover: _cache[1] || (_cache[1] = ($event: any) => (cartButtonHover.value = true)),
          onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (cartButtonHover.value = false))
        }, {
          icon: _withCtx(() => [
            _createVNode(_unref(NIcon), null, {
              default: _withCtx(() => [
                _createVNode(_unref(ShoppingCart))
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createTextVNode(" Cart "),
            _createVNode(_unref(NBadge), {
              value: _unref(store).cartProductCount,
              style: {"margin-left":"5px"}
            }, null, 8, ["value"])
          ]),
          _: 1
        }, 8, ["ghost"])
      ]),
      _: 1
    })
  ]))
}
}

})